import React, { useEffect, useState } from "react";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../environment/BackendService";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { useModal } from "../../../common_nextgen/hooks/ModalContext";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";
import {
  useLocationState,
  useReceiveExternalMessages,
} from "../../../common_nextgen/common_components/common-hooks/useLocationState";

const useCodesInAdjustmentReasonCodeList = () => {
  const { axios_helper_no_header } = useAxios();
  const [data, setData] = useState([]);
  const location = useLocation();
  const { showModal } = useModal();
  const {
    ADD_PRICE_SCHEDULE,
    EDIT_PRICE_SCHEDULE,
    DISPLAY_PRICE_SCHEDULE,
    COPY_PRICE_SCHEDULE,
    ACCUMULATION_CODE_LIST,
  } = ROUTE_PATHS;
  /* const { state: stateVal } = location;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  console.log("current state in form", currentState, previousState);*/
  const { currentState, previousState, setStateVal } = useLocationState({
    initialState: location.state ?? [],
  });
  const {
    selectedSchedules = [],
    previousScreen = ACCUMULATION_CODE_LIST,
    currentIndex: initialIndex = 0,
    externalMode: initialExternalMode = false,
    paramsData: initialParamsData = {
      ad1AdjReasonCodeList:
        selectedSchedules[initialIndex]?.ad1AdjReasonCodeList,
      ad1AdjRsnCdeLstDesc: selectedSchedules[initialIndex]?.ad1AdjRsnCdeLstDesc,
      adjAdjustmentCode: selectedSchedules[initialIndex]?.adjAdjustmentCode,
    },
    externalScreenNumber = null,
    externalScreenTitle = null,
  } = currentState;
  console.log("InitialparamsData", initialParamsData);
  console.log("prevstate", previousState);

  const [paramsData, setParamsData] = useState(initialParamsData);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [externalMode, setExternalMode] = useState(initialExternalMode);
  useReceiveExternalMessages(setStateVal, setExternalMode);
  const screen_title = externalScreenTitle ?? "Codes in Adjustment Reason Code List";
  const screenNumber = externalScreenNumber ?? "RCAD2001";
  const formFields = [
    {
      fieldLabel: "AD1 Adj Reason Code List",
      name: "ad1AdjReasonCodeList",
      label: "List",
      type: "text",
      fieldNature: "readOnly",
      value: "ad1AdjReasonCodeList",
      maxLength: 10,
    },
    {
      fieldLabel: "AD1 Adj Rsn Cde Lst Desc",
      name: "ad1AdjRsnCdeLstDesc",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      value: "ad1AdjRsnCdeLstDesc",
      maxLength: 25,
    },
    {
      fieldLabel: "ADJ Adjustment Code",
      name: "adjAdjustmentCode",
      label: "Code",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
  ];

  const handleReceiveData = async (data) => {
    const listData = {
      ...data,
      ad1AdjReasonCodeList: paramsData.ad1AdjReasonCodeList,
      screenNumber: screenNumber,
    };
    try {
      const { responseStatus } = await axios_helper_no_header(
        "POST",
        "api/ad2AdjRsnCodeLstDtl",
        listData,
        null
      );
      toast.current.show({
        severity: "success",
        summary: "",
        detail: responseStatus.message,
        life: 3000,
      });
    } catch (e) {
      console.error("There was an error selecting the data!", e);
      const {
        responseStatus: { /*displayErrorFields = null,*/ message } = {},
      } = e.data;
      toast.current.show({
        severity: "error",
        summary: "",
        detail: message,
        life: 3000,
      });
    } finally {
      const updatedParamsData = {
        ...paramsData,
        adjAdjustmentCode: data["adjAdjustmentCode"],
      };
      setParamsData(updatedParamsData);
    }
  };

  const ctaButtons = [
    ...(externalScreenNumber !== "RCAD2003" ? [{
      button_label: "Add Codes in Adjustment Reason Code List",
      button_handeler: () => {
        showModal(
          {
            default: "AdjustmentReasonCode",
          },
          {
            params: {
              lookupType: "local",
              fieldMapping: {
                default: [
                  {
                    source: "adjAdjustmentCode",
                    target: "adjAdjustmentCode",
                  },
                ],
              },
            },
          },
          handleReceiveData
        );
      },
      button_key: "F6",
    }] : []),
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  const handleBack = () => {
    if (externalMode) {
      const message = {
        message: "navigate-to-external-program",
        url: previousScreen,
        parameters: {
          state: [...previousState],
        },
      };
      console.log("back messages", message);
      window.parent.postMessage(message, "*");
    } else if (currentIndex < selectedSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  /* Top Left Back button info that needs to be displayed on the page*/
  const leftButtons = [
    { button_label: "Back", button_handeler: handleBack, button_key: "F12" },
  ];

  const menuOptions = [
    ...(externalScreenNumber !== "RCAD2003" ? [
    {
      label: "Delete",
      icon: <span className="material-icons">delete</span>,
      command: () => {
        openConfirmationModal();
      },
    }]: []),
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        const selectedRecords = selectedRows.length
          ? [...selectedRows]
          : [{ ...rowData }];
        const lastRecord = selectedRecords.pop() || { adjAdjustmentCode: "" };
        const updatedParamData = {
          ...paramsData,
          adjAdjustmentCode: lastRecord?.adjAdjustmentCode,
        };
        console.log("updated", updatedParamData);
        navigateToPage(ROUTE_PATHS.ADJUSTMENT_REASON_CODE_DISPLAY, [
          ...previousState,
          {
            ...currentState,
            currentIndex,
            paramsData: updatedParamData,
            externalMode,
          },
          {
            selectedAdjustmentReason: selectedRows.length
              ? selectedRows
              : [rowData],
            previousScreen: location.pathname,
            currentIndex: 0,
          },
        ]);
      },
    },
  ];

  const columnDef = [
    {
      header: "Code",
      field: "adjAdjustmentCode",
    },
    {
      header: "Description",
      field: "adjRsnCdeDesc",
    },
  ];

  const parmKey1 = "ad1AdjReasonCodeList";
  const parmKey2 = "adjAdjustmentCode";

  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/ad2AdjRsnCodeLstDtl`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  useEffect(() => {
    const hasParams =
      paramsData &&
      Object.keys(paramsData).length &&
      paramsData.ad1AdjReasonCodeList;
    if (hasParams) fetchData();
  }, [paramsData, rows, currentPage, externalMode]);

  useEffect(() => {
    if (currentIndex != initialIndex) {
      setParamsData({
        ad1AdjReasonCodeList:
          selectedSchedules[currentIndex]?.ad1AdjReasonCodeList,
        ad1AdjRsnCdeLstDesc:
          selectedSchedules[currentIndex]?.ad1AdjRsnCdeLstDesc,
        adjAdjustmentCode: "",
      });
    }
  }, [currentIndex]);

  useEffect(() => {
    if (
      !paramsData.ad1AdjReasonCodeList &&
      initialParamsData.ad1AdjReasonCodeList
    ) {
      setParamsData(initialParamsData);
    }
  }, [initialParamsData]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deleteAdjustmentReasonCode = () => {
    if (selectedOption === "yes") {
      const params = {
        ad1AdjReasonCodeList: rowData[parmKey1],
        adjAdjustmentCode: rowData[parmKey2],
      };
      axios_helper_no_header("DELETE", "api/ad2AdjRsnCodeLstDtl", null, params)
        .then((response) => {
          const updatedItems = data.filter(
            (item) => item[parmKey2] !== rowData
          );
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/ad2AdjRsnCodeLstDtl/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey1,
    parmKey2,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteAdjustmentReasonCode,
    setSelectedOption,
  };
};

export default useCodesInAdjustmentReasonCodeList;
